import React, { useEffect, useState } from 'react'
import { FormField } from '../../FormField'
import { connect } from 'react-redux'
import { loginAction, getAllTerminalsAction } from '../../../actions/admin/adminTerminals'
import { getAdminToken } from '../../../actions/api'
import DevTools from '../../DevTool'
import logo from '../../../assets/logo.png'
import './login.less'
import { AppState } from '../../../reducers'

const errorLoginMessage = 'The User Name or Password is Incorrect'

const mapStateToProps = (state: AppState) => ({
  isShowErrorLogin: state.adminTerminals.isShowErrorLogin,
})
type StateProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {
  login: loginAction,
  getAllTerminals: getAllTerminalsAction,
}
type DispatchProps = typeof mapDispatchToProps
type Props = DispatchProps & StateProps

const Component: React.FC<Props> = ({ login, getAllTerminals, isShowErrorLogin }: Props) => {
  const [username, setUsername] = useState()
  const [password, setPassword] = useState()
  const [showDevTools, toggleDevTools] = useState(false)

  const onLogin = (event: any) => {
    event.preventDefault()
    login({ username, password })
  }

  useEffect(() => {
    if (getAdminToken()) {
      getAllTerminals()
    }
  }, [getAllTerminals])

  return (
    <div className="admin-home">
      <div className="admin-main">
        <div className="admin-home-title">CSC Admin Console</div>
        <form className="admin-home-form" onSubmit={onLogin}>
          <FormField
            id=""
            label="email"
            classFormField="form-field"
            isError={isShowErrorLogin}
            sublabel={isShowErrorLogin ? errorLoginMessage : ''}
          >
            <input
              className={isShowErrorLogin ? 'admin-field-input error-input' : 'admin-field-input'}
              placeholder="example@domain.com"
              value={username}
              onChange={(e: any) => setUsername(e.target.value)}
            />
          </FormField>
          <FormField
            id=""
            label="password"
            classFormField="form-field"
            isError={isShowErrorLogin}
            sublabel={isShowErrorLogin ? errorLoginMessage : ''}
          >
            <input
              className={isShowErrorLogin ? 'admin-field-input error-input' : 'admin-field-input'}
              type="password"
              placeholder=""
              value={password}
              onChange={(e: any) => setPassword(e.target.value)}
            />
          </FormField>
          <button className="admin-main-button" type="submit">
            LOGIN
          </button>
        </form>
      </div>
      <img
        className="logo"
        src={logo}
        style={{ position: 'absolute', bottom: '30px' }}
        alt="logo"
        onClick={() => toggleDevTools(!showDevTools)}
      />
      {showDevTools && <DevTools onClose={() => toggleDevTools(false)} />}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
